import React from 'react'

const DrawerIcon = () => {
    return (
        <svg className='drawer-icon' width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="29.5" cy="29.5" r="28.5" transform="rotate(90 29.5 29.5)" stroke="black" strokeWidth="2"/>
            <path d="M43 26L30.4144 38.5856C29.6333 39.3667 28.367 39.3667 27.5859 38.5856L15.0003 26" stroke="black" strokeWidth="2" strokeLinecap="round"/>
        </svg>

    )
}

export default DrawerIcon